<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(true);
  pagingStore.showNext(true);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(true);
  laraStore.setOpacity(1);

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("gray");
  stylesColor.set("black");
</script>

<div class="page">
  <Quote title="Tag 6">
    Jedem Validarier, der sich abschätzig zu DAUs äussert, muss leider auswandern.
  </Quote>
</div>
